jQuery(window).load(function(){
  
  
  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    animationDuration: 700,
    slideshowSpeed: 2000,
    animation: "fade",
    controlsContainer: ".flex-controls",
    controlNav: false,
    keyboardNav: true
  }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});
  
  
  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });
    
  
});

jQuery(document).ready(function($){
  
  $(".tweet").tweet({ // twitter plugin
    username: "shopify",
    join_text: "auto",
    avatar_size: 32,
    count: 2,
    auto_join_text_default: "", 
    auto_join_text_ed: "",
    auto_join_text_ing: "",
    auto_join_text_reply: "",
    auto_join_text_url: "",
    loading_text: "Loading Tweets..."
  });
  	
  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
  $('#product .thumbs a').click(function(){
    
    $('#placeholder').attr('href', $(this).attr('href'));
    $('#placeholder img').attr('src', $(this).attr('data-original-image'))
    
    $('#zoom-image').attr('href', $(this).attr('href'));
    return false;
  });
  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })
  
  $("li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
  $('a[href^="#"]').bind('click.smoothscroll',function (e) {
    e.preventDefault();
    
    var target = this.hash,
        $target = $(target);
    
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top
    }, 500, 'swing', function () {
        window.location.hash = target;
    });
  });
  
  var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll')
    .click(function(e) {
         var contentLocation = $(this).attr('href');
    	 if(contentLocation.charAt(0)=="#") {            
  		tabs.removeClass('active');
  		$(this).addClass('active');
  		$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  });
  
    
}); // end document ready

    
    
// add spaces around / in product page titles

 
// remove "News" header from /news/
var currentUrl = window.location.href;
    
$(function() {
  if (currentUrl.indexOf('news') == currentUrl.length - 4) {
      $('.title .span12 h1').css('display', 'none');
    }
});
    
// remove "Arists" header from /collections/
var currentUrl = window.location.href;
    
$(function() {
  if (currentUrl.indexOf('collections') == currentUrl.length - 11) {
      $('#collection .span12').css('display', 'none');
    }
});
    
    
// Hide Gear from Collections page
$(function() {
   if (( document.location.href.indexOf('/collections') > -1 ) 
   	  )
   		{
   		  $('a[href$="/gear"]').closest("div.product").hide();
          $('a[href$="/frontpage"]').closest("div.product").hide();
      //    $( ".span12 h1 span" ).append("<div class='artists'>Artists</div>" );
		}
	});
    
// Hide Gear from Collections page
$(function() {
   if (( document.location.href.indexOf('/collections') > -1 ) 
   	  )
   		{
   		  $('a[href$="/store"]').closest("div.product").hide();
		}
	});

// remove "Front page" from those products in that collection
$(function() {
   if (window.location.href.indexOf('frontpage') >= 0) { 
   	    $('.span6 h1 a').css('visibility', 'hidden');
     }  
});
    
// remove "Front page" from those products in that collection
$(function() {
   if (window.location.href.indexOf('store') >= 0) { 
   	    $('.span6 h1 a').css('visibility', 'hidden');
     }  
});

// Add "the" in front of King Khan...
$(function() {
   if (window.location.href.indexOf('the-king-khan-and-bbq-show') >= 0) { 
   	    $('#collection h1').addClass("add-the");
     }  
});
    
// Change "williams, andre" to "andre williams"
$(function() {
   if (window.location.href.indexOf('andre-williams') >= 0) { 
   	    $('.collection-title').text('Andre Williams');
     }  
});



// Read More
var $el, $ps, $up, totalHeight;

$(".sidebar-box .button").click(function() {
			
	totalHeight = 0

	$el = $(this);
	$p  = $el.parent();
	$up = $p.parent();
	$ps = $up.find("p:not('.read-more')");
	
	// measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
	$ps.each(function() {
		totalHeight += $(this).outerHeight();
	});
				
	$up
		.css({
			// Set height to prevent instant jumpdown when max height is removed
			"height": $up.height(),
			"max-height": 9999
		})
		.animate({
			"height": totalHeight
		});
	
	// fade out read-more
	$p.fadeOut();
	
	// prevent jump-down
	return false;
		
}); // End Read more
    

// Columns alignment fix in artists drop down
//$("nav > ul > li.dropdown > .dropdown").prepend('<li style="height:height: 0!important ;margin-top: -4px;"><a href="#"></a></li>');
    
// if (GF) is present, add gluten-free class
  $("h1.title").text(function () {
  return $(this).text().replace("/", " – "); 
});

// Safari only css
(function($){
    // console.log(navigator.userAgent);
    /* Adjustments for Safari on Mac */
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        // console.log('Safari on Mac detected, applying class...');
        $('html').addClass('safari-mac'); // provide a class for the safari-mac specific css to filter with
    }
})(jQuery);